import { AuthoringLeaveGuard } from "./AuthoringLeaveGuard";

// UI-LAW §4c Authoring: route-level leave-guard on dirty form state, shared by
// /markers/new and /markers/$markerId/edit. In-app navigations block through
// the router and confirm through the Modal primitive (§4a: a destructive-of-
// work confirm — "Keep editing" is the one primary action, "Discard changes"
// the §2.12 danger, last). Hard unloads (refresh/tab close) keep the browser's
// native beforeunload prompt — the only mechanism a browser offers for that
// path, so no custom chrome is possible there.
export function MarkerAuthoringLeaveGuard({ isDirty }: { isDirty: boolean }) {
  return <AuthoringLeaveGuard isDirty={isDirty} subject="marker" />;
}
